export default __webpack_public_path__ + "static/media/upload.6e264349.svg";